<!--
 * @Author: sunluhua 1057254519@qq.com
 * @Date: 2023-12-13 17:06:18
 * @LastEditors: sunluhua 1057254519@qq.com
 * @LastEditTime: 2024-01-16 16:38:12
 * @FilePath: /bbb-bbc-admin/src/views/statisticalReport/freightPayoffReport/table.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-table
    :data="list"
    style="width: 100%"
    tooltip-effect="light"
    ref="multipleTable"
    @selection-change="handleSelectionChange">
      <el-table-column
        v-if="multiSelect"
        type="selection"
        width="55" />
        <template v-for="item in columns">
        <el-table-column
          v-if="!item.hide"
          :label="item.name" :key="item.prop" :prop="item.prop"
          :width="item.width ? item.width : '80'"
          show-overflow-tooltip
          :fixed="item.fixed ? item.fixed : false">
          <!-- <slot v-if="item.slot" :name="item.slot"></slot> -->
        </el-table-column>
        </template>
        <el-table-column
        label="操作" width="400" v-if="isFreight">
          <template  slot-scope="scope">
            <el-button v-permission="'0172802'"  @click="batchOneOperation(0,scope.row)">到票</el-button>
            <el-button v-permission="'0172803'" @click="batchOneOperation(1,scope.row)">运费结算</el-button>
            <el-button v-permission="'0172804'" @click="batchOneOperation(2,scope.row)">取消到票</el-button>
            <el-button v-permission="'0172805'" @click="batchOneOperation(3,scope.row)">取消运费结算</el-button>
           </template>
         </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'freightTable',

  props: {
    list: {
      required: true,
      type: Array
    },
    columns: {
      type: Array,
      required: true
    },
    freightType: {
      type: Number,
      default: 0
    },
    multiSelect: {
      type: Boolean,
      default: true
    },
    isFreight: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
    }
  },

  mounted () {
  },

  methods: {
    handleSelectionChange (val) {
      this.$emit('select', val)
    },
    batchOneOperation (type, row) {
      this.$emit('batchOneOperationEmit', type, row)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
